import React from "react";
import "../projects/projects.css";
import "./prototypes.css";

const GH = "https://github.com/harshitb01/";

const prototypes = [
  {
    title: "Spider Cabin",
    role: "Scream Jam · Unity",
    description:
      "First-person survival horror featuring exploration, item collection, inventory management, stamina and hydration systems, mission progression, enemy AI, and scene transitions. Focused on an immersive gameplay loop with environmental storytelling and a clear objective-driven structure.",
    tags: ["Unity", "Survival Horror", "AI", "Game Jam"],
    repo: "SpiderCabin",
    play: "https://pikonparadox.itch.io/spider-cabin",
  },
  {
    title: "Brackeys Game Jam 2025",
    role: "Gameplay Programming · Audio · VFX",
    description:
      "A complete WebGL game built in one week with a five-person team. Ranked in the Top 250 of 2,300+ entries — rapid prototyping and collaborative development under a tight deadline.",
    tags: ["WebGL", "Team of 5", "Top 250 / 2300+", "Game Jam"],
    repo: "BrackeysGameJam2025",
    play: "https://tihan.itch.io/you-cannot-go-back",
  },
  {
    title: "Two Bodies, One Soul",
    role: "Physics Puzzle · Unity",
    description:
      "A physics-based puzzle game where two characters are bound by gravity's duality — one in normal gravity, one reversed. Switch between souls to cut bouncing balls that split into smaller fragments until they vanish, mastering teamwork, precision, and timing before time runs out.",
    tags: ["Unity", "Physics", "Puzzle", "Game Jam"],
    play: "https://01harry01.itch.io/two-bodies-one-soul",
  },
  {
    title: "BYOG Game Jam Project",
    role: "Level Design · Gameplay · Unity",
    description:
      "A collaborative Unity adventure game built during a game jam, with multiple handcrafted levels that each introduce a unique mechanic or twist — diverse systems held together in one cohesive player experience.",
    tags: ["Unity", "Level Design", "Game Jam"],
    repo: "byog_Untitled_game",
    play: "https://01harry01.itch.io/think-twice",
  },
  {
    title: "AR App (Vuforia)",
    role: "Mobile AR · Unity + Vuforia",
    description:
      "An augmented reality application demonstrating real-time image tracking, AR interactions, and spatial content placement — hands-on experience building immersive mobile AR experiences.",
    tags: ["Unity", "Vuforia", "AR", "Mobile"],
    repo: "ARAppVufoira",
  },
  {
    title: "Horde Shooter",
    role: "Survival Combat Prototype",
    description:
      "A fast-paced survival prototype with wave-based enemy spawning, combat systems, and scalable mechanics — exploring player progression, enemy behaviour, and performance optimisation for action-heavy gameplay.",
    tags: ["Unity", "Wave Spawning", "Optimisation"],
    repo: "HordeShooter",
  },
  {
    title: "Arena Shooter",
    role: "Combat Systems Prototype",
    description:
      "A combat-focused prototype with responsive player controls, weapon systems, enemy encounters, and gameplay balancing — reusable combat architecture suitable for larger action titles.",
    tags: ["Unity", "Weapon Systems", "Balancing"],
    repo: "ArenaShooter",
  },
  {
    title: "UNO Prototype",
    role: "Card Game · Multiplayer-Ready",
    description:
      "Recreates the popular card game's mechanics with an emphasis on multiplayer-ready architecture, turn management, rule validation, and extensible gameplay logic suitable for online play.",
    tags: ["Unity", "Turn-Based", "Rule Validation"],
    repo: "UNOProto",
  },
  {
    title: "Chess Prediction Game",
    role: "Turn-Based Systems",
    description:
      "Combines traditional chess mechanics with prediction-based interactions — a study in complex game state management, rule systems, and turn-based architecture.",
    tags: ["Unity", "Game State", "Rule Systems"],
    repo: "ChessPredictionGame",
  },
  {
    title: "Cargo Simulation",
    role: "Systems & Simulation",
    description:
      "A systems-driven logistics prototype focused on resource movement, object interactions, and simulation mechanics — designing scalable gameplay systems beyond traditional action games.",
    tags: ["Unity", "Simulation", "Systems Design"],
    repo: "CargoSimulation",
  },
  {
    title: "Tic Tac Toe",
    role: "Architecture Study",
    description:
      "A polished take on the classic strategy game built to demonstrate clean game architecture, modular UI systems, and scalable gameplay logic that extends easily into multiplayer or AI opponents.",
    tags: ["Unity", "Modular UI", "Clean Architecture"],
    repo: "TicTacToe",
  },
];

const Prototypes = () => {
  return (
    <section id="prototypes">
      <h5>Experiments & Game Jams</h5>
      <h2>Prototypes</h2>
      <div className="container projects__container proto__container">
        {prototypes.map((p) => (
          <article className="project__card proto__card" key={p.title}>
            <div className="project__body">
              <h3 className="project__title">{p.title}</h3>
              <p className="project__role">{p.role}</p>
              <p className="project__desc">{p.description}</p>
              <ul className="project__tags">
                {p.tags.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
              <div className="proto__links">
                {p.play && (
                  <a className="btn btn-primary" href={p.play} target="_blank" rel="noopener noreferrer">
                    Play
                  </a>
                )}
                {p.repo && (
                  <a className="btn btn-ghost" href={`${GH}${p.repo}`} target="_blank" rel="noopener noreferrer">
                    GitHub
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Prototypes;
